// extracted by mini-css-extract-plugin
export default {"root":"SectionGreenBanner_root__JyMIX","content":"SectionGreenBanner_content__ayqqC","headline":"SectionGreenBanner_headline__sRmSL","subtext":"SectionGreenBanner_subtext__+FtTZ"};